export function formatViews(value: number): string {
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)} 万`;
  }
  return value.toLocaleString("zh-CN");
}

export function formatDuration(minutes: number): string {
  const mm = Math.floor(minutes);
  const ss = Math.round((minutes - mm) * 60);
  return `${String(mm).padStart(2, "0")}:${String(ss).padStart(2, "0")}`;
}

export function formatDate(value: string): string {
  return value.replace(/-/g, ".");
}

export function matchesKeyword(keyword: string, fields: Array<string | string[]>): boolean {
  const word = keyword.trim().toLowerCase();
  if (!word) {
    return true;
  }
  const pool = fields
    .map((field) => (Array.isArray(field) ? field.join(" ") : field))
    .join(" ")
    .toLowerCase();
  return pool.includes(word);
}